// Client-side validation helpers
export const validateEmail = (email: string): string | null => {
  if (!email.trim()) {
    return 'Email is required';
  }
  
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  if (!emailRegex.test(email)) {
    return 'Please enter a valid email address';
  }
  
  return null;
};

export const validatePassword = (password: string): string | null => {
  if (!password) {
    return 'Password is required';
  }
  
  if (password.length < 6) {
    return 'Password must be at least 6 characters long';
  }
  
  return null;
};

export const validateName = (name: string): string | null => {
  if (!name.trim()) {
    return 'Name is required';
  }
  
  if (name.trim().length < 2) {
    return 'Name must be at least 2 characters long';
  }
  
  return null;
};

export const validateForm = (data: {
  email: string;
  password: string;
  name?: string;
  isSignup?: boolean;
}): string | null => {
  const emailError = validateEmail(data.email);
  if (emailError) return emailError;
  
  const passwordError = validatePassword(data.password);
  if (passwordError) return passwordError;
  
  if (data.isSignup && data.name !== undefined) {
    const nameError = validateName(data.name);
    if (nameError) return nameError;
  }
  
  return null;
};
